// extracted by mini-css-extract-plugin
module.exports = {"container__article":"Article_container__article__2UxYe"};